import React from 'react';

const Logo = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: { icon: 32, text: 'text-lg' },
    default: { icon: 40, text: 'text-2xl' },
    large: { icon: 56, text: 'text-4xl' },
    hero: { icon: 80, text: 'text-6xl' },
  };

  const { icon, text } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Logo Icon - Stylized "M" with coin/growth motif */}
      <svg
        width={icon}
        height={icon}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Background circle with gradient */}
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#059669" />
            <stop offset="100%" stopColor="#064E3B" />
          </linearGradient>
          <linearGradient id="coinGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FCD34D" />
            <stop offset="100%" stopColor="#F59E0B" />
          </linearGradient>
        </defs>
        
        {/* Main circle background */}
        <circle cx="40" cy="40" r="38" fill="url(#logoGradient)" />
        
        {/* Inner coin circle */}
        <circle cx="40" cy="40" r="28" fill="url(#coinGradient)" opacity="0.9" />
        
        {/* Stylized "M" for Maa - representing family/togetherness */}
        <path
          d="M24 52V32L32 44L40 28L48 44L56 32V52"
          stroke="#064E3B"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* Small growth arrow accent */}
        <path
          d="M54 24L60 18M60 18L60 24M60 18L54 18"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Subtle rupee symbol hint */}
        <circle cx="40" cy="40" r="28" stroke="white" strokeWidth="1.5" opacity="0.3" />
      </svg>

      {/* Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold ${text} text-primary tracking-tight leading-none`}>
            Maa Dabbu
          </span>
          <span className={`${size === 'small' ? 'text-[9px]' : size === 'hero' ? 'text-sm' : 'text-xs'} text-gray-400 italic`}>
            By Buddi
          </span>
          {size === 'hero' && (
            <span className="text-sm text-gray-500 mt-1">Family Wealth Management</span>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
